import script from "./BriefOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./BriefOverview.vue?vue&type=script&setup=true&lang=ts"

import "./BriefOverview.vue?vue&type=style&index=0&id=7f7e1a3a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f7e1a3a"]])

export default __exports__